export default __webpack_public_path__ + "static/media/map.3805197e.svg";